export default "Pompe à chaleur air/eau ou eau/eau tertiaire (fiche CEE BAT-TH-104). Coup de pouce CVC mobilisable si remplacement chaudière fossile. Levier-clé du plan -40 % OPERAT.";
